import { render, staticRenderFns } from "./AdminStudentListGrid.vue?vue&type=template&id=1380d21e"
import script from "./AdminStudentListGrid.vue?vue&type=script&lang=js"
export * from "./AdminStudentListGrid.vue?vue&type=script&lang=js"
import style0 from "./AdminStudentListGrid.vue?vue&type=style&index=0&id=1380d21e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports